<template>
    <div class="ticket-candy">
        <!--<h2 class="ticket-candy__title" v-if="p_candy.strTitle"><span>{{ p_candy.strTitle }}</span></h2>-->
        <div class="ticket-candy__content">
            <div class="ticket-candy__img" :class="{ 'ticket-candy__img-full': !p_candy.strDescription }">
                <div>
                    <img :src="this.$root.d_get_url_candy_images + this.p_candy.strMCode + '.png?v=' + this.$root.d_get_date_version_cache" alt="">
                </div>
            </div>
            <div class="ticket-candy__desc" v-if="p_candy.strDescription">
                <span>{{ p_candy.strDescription }}</span>
            </div>
        </div>
        <div class="ticket-candy__price">
            <div v-for="(option, index) in p_candy.BuyOptions" :key="index" :class="option.strCssClass">
                <template v-if="p_candy.BuyOptions.length == 1">
                    <a class="option-unique" @click.prevent="m_add_candy(option.intRecogId, option.intPromoId)" :class="[{ 'ticket-candy__price-selected': m_get_ticket_candy_qty(option) > 0 }, option.strCssClass]" :alt="option.strDescription" href="#">
                        <span v-html="m_total(option)"></span>
                        <span class="wtax" v-if="option.intValueWTax > 0">Precio sin impuestos nacionales: $ {{ ((option.intValueWTax * option.intButtonQty) / 100).toLocaleString('es-AR') }}</span>
                    </a>
                </template>
                <template v-else>
                    <a @click.prevent="m_add_candy(option.intRecogId, option.intPromoId)" :class="[{ 'ticket-candy__price-selected': m_get_ticket_candy_qty(option) > 0 }, { 'option-first': index === 0, 'option-last': index === (p_candy.BuyOptions.length - 1) }, option.strCssClass]" :alt="option.strDescription" href="#">
                        <span v-html="m_total(option)"></span>
                        <span class="wtax" v-if="option.intValueWTax > 0">Precio sin impuestos nacionales: $ {{ ((option.intValueWTax * option.intButtonQty) / 100).toLocaleString('es-AR') }}</span>
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";

export default {
    name: 'candyticket',
    props: {
        p_candy: { type: Object, default: () => null }
    },
    computed: {
    },
    methods: {
        m_add_candy: function (intRecogId, intPromoId) {
            this.$root.m_add_candy(this.p_candy.strMCode, this.p_candy.strBarcode, intRecogId, intPromoId);
        },
        m_del_candy: function (intRecogId, intPromoId) {
            this.$root.m_del_candy(this.p_candy.strMCode, this.p_candy.strBarcode, intRecogId, intPromoId);
        },
        m_total: function (option) {
            var price = "";
            var balances = "";
            var hasPoints = false;
            if (option.intValue > 0) {
                price += `<span class="ticket-price-now">$ ${((option.intValue * option.intButtonQty) / 100).toLocaleString('es-AR')}</span>`;
            }
            if (option.lstBalances.length == 1) {
                option.lstBalances.forEach(balance => {
                    if (balance.intPoints > 0) {
                        hasPoints = true;
                        balances += `<span class="ticket-price-now">${balance.intPoints.toLocaleString('es-AR')}</span><small class="ticket-price-span">${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, (balance.intPoints > 1))}</small>`;
                    }
                });
            }
            if (option.lstBalances.length > 1) {
                option.lstBalances.forEach(balance => {
                    if (balance.intPoints > 0) {
                        hasPoints = true;
                        if (balances.length > 0) {
                            balances += " + ";
                        }
                        balances += `<small class="ticket-price-span">${balance.intPoints.toLocaleString('es-AR')} ${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, (balance.intPoints > 1))}</small>`;
                    }
                });
            }
            if (!hasPoints && option.intValue == 0) {
                price = '$0'
            }
            if (hasPoints && option.intValue > 0) {
                price += ' + ';
            }

            var priceDesc = "";

            if (this.$root.d_show_promotion_desc && option.strDescription != undefined) {
                priceDesc = ` <span class="ticket-price-span">${option.strDescription}</span>`;
            }
            else {
                if (this.$root.d_member && this.$root.d_member.intLoyaltyLevel > 1 && option.intType == 3 && option.intRecogId != 0) {
                    priceDesc = `<span class="ticket-price-span">PRECIO CINE FAN</span>`;
                }
                else {
                    if (this.m_validate_show_price_before(option)) {
                        priceDesc = `<span class="ticket-price-span">PRECIO WEB</span>`;
                    }
                }
            }

            return price + balances + priceDesc;
        },
        m_get_ticket_candy_qty: function (option) {
            return this.$root.m_get_ticket_candy_qty(this.p_candy.strMCode, this.p_candy.strBarcode, option.intRecogId, option.intPromoId);
        },
        m_validate_show_price_before(option) {
            var resp = false;
            if (option.intValue == 0)
                return false;

            if (option.intType == 3) {
                if ((option.intRecogId != 0 && this.p_candy.SalePrice > option.intValue)) {
                    resp = true;
                }
                if (this.p_candy.PercentDiscount != 0 && this.p_candy.SalePrice * 100 > option.intValue) {
                    resp = true;
                }
            }
            return resp;
        },
        m_getDate: function () {
            return moment();
        },
        m_get_balance_name: function (enuPointsType, intBalanceId, plural) {
            return this.$root.m_get_balance_name(enuPointsType, intBalanceId, false, plural);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/CandyTicket.vue